@if(loading) {
<p-skeleton
    [width]="getSkeletonSize()"
    [height]="getSkeletonSize()"
    [shape]="shape"
    styleClass="shimmer-avatar"
/>
} @else if(user?.photoUrl) {
<p-avatar
    [style.background-color]="backgroundColor"
    [style.color]="foregroundColor"
    [image]="user?.photoUrl"
    [shape]="shape"
    [size]="size"
    (click)="op.toggle($event)"
/>
} @else if(user) {
<p-avatar
    [style.background-color]="backgroundColor"
    [style.color]="foregroundColor"
    [label]="(user.displayName?.charAt(0)?.toUpperCase() || '') | titlecase"
    [shape]="shape"
    [size]="size"
    (click)="op.toggle($event)"
/>
} @else {
<p-avatar
    [style.background-color]="'#cccccc'"
    [style.color]="'#666666'"
    [label]="'?'"
    [shape]="shape"
    [size]="size"
/>
}

<p-popover #op>
    <div class="flex flex-col">
        <span class="font-medium">{{ user?.displayName }}</span>
        @if(user?.email){
        <div
            class="mt-1 after:text-sm text-surface-500 dark:text-surface-400"
            >{{ user?.email?.value }}</div
        >
        } @if(user?.mobileNumber){
        <div class="text-sm text-surface-500 dark:text-surface-400">{{
            user?.mobileNumber?.value
        }}</div>
        }
    </div>
</p-popover>
